module Core {
    export enum PortionType {
        Simple = 0,
        Famille = 1,
        Duo = 2
    }
}